<template>
  <div style="width: 100%;height: 100%;">
  <el-row :gutter="10" style="margin-bottom:10px;width: 100%">
    <el-col :span="4">
      <el-cascader
          v-model="deptId"
          :show-all-levels="false"
          :options="deptCascader"
          :props="optionProps"
          placeholder="部门"
          clearable
      ></el-cascader>
    </el-col>
    <el-col :span="4">
      <el-input v-model="employeeNo" placeholder="员工工号" clearable/>
    </el-col>
    <el-col :span="4">
      <el-input v-model="employeeName" placeholder="员工姓名" clearable/>
    </el-col>
    <el-col :span="4">
      <el-date-picker v-model="selectMonth" type="month" placeholder="请选择月份" value-format="YYYY-MM"/>
    </el-col>
  </el-row>
  <el-row :gutter="10" style="margin-bottom:10px;width: 100%">
    <el-col :span="4">
      <el-select v-model="sendStatus" placeholder="推送状态" clearable>
        <el-option label="待推送" value="wait_send" />
        <el-option label="已推送" value="sent" />
        <el-option label="推送失败" value="send_fail" />
      </el-select>
    </el-col>
    <el-col :span="4">
      <el-select v-model="confirmStatus" placeholder="确认状态" clearable>
        <el-option label="待确认" value="wait_confirm" />
        <el-option label="已确认" value="confirmed" />
        <el-option label="有异议" value="opinion" />
        <el-option label="超时" value="timeout" />
      </el-select>
    </el-col>
    <el-col :span="12">
      <el-button type="primary" @click="getMonthReport" :loading="searchLoading" >搜索</el-button>
      <!--     <el-button type="primary" plain @click="resetParam" >重置</el-button>-->
      <el-button type="primary" @click="alertSum">考勤计算</el-button>
      <el-button type="primary" plain @click="exportMonthReport">导出</el-button>
<!--      <el-button type="primary" plain @click="sendWx">推送</el-button>-->
    </el-col>
  </el-row>
<!--  <el-row  :gutter="5" style="margin-bottom: 10px">
    <el-col :span="8">
      &lt;!&ndash;      <FrameButton :button="sumButton"></FrameButton>&ndash;&gt;
      <el-button type="primary" @click="alertSum">考勤计算</el-button>
      <el-button type="primary" plain @click="exportMonthReport">导出</el-button>
      <el-button type="primary" plain @click="sendWx">推送</el-button>
    </el-col>
  </el-row>-->
  <el-table :data="pageAttendanceList" :span-method="spanMethod" stripe border style="width: 100%;height: 77%" row-style="height:28px;" size="small">
    <el-table-column label="工号" prop="employee_no" fixed width="70" align="center" ></el-table-column>
    <el-table-column label="姓名" prop="employee_name" fixed width="80" align="center" ></el-table-column>
    <el-table-column label="部门" prop="department_name" fixed width="100" align="center" ></el-table-column>
    <el-table-column label="入职日期" prop="entry_date" fixed width="100" align="center" ></el-table-column>
    <el-table-column label="考勤月份" prop="work_month_str" width="70" align="center" ></el-table-column>
    <el-table-column label="推送状态" prop="send_status_name" width="70" align="center" ></el-table-column>
    <el-table-column label="确认状态" prop="confirm_status_name" width="70" align="center" ></el-table-column>
    <el-table-column label="应出勤(天)" prop="attendance_days" width="55" align="center" ></el-table-column>
    <el-table-column label="实际出勤(天)" prop="actual_attendance_days" width="65" align="center" ></el-table-column>
    <el-table-column label="应出勤(H)" prop="attendance_hours" width="55" align="center" ></el-table-column>
    <el-table-column label="实际出勤(H)" prop="actual_attendance_hours" width="65" align="center" ></el-table-column>
    <el-table-column label="节假日(H)" prop="holiday_hours" width="55" align="center" ></el-table-column>
    <el-table-column label="加班(H)" prop="overtime_hours" width="45" align="center" ></el-table-column>
    <el-table-column label="出差(H)" prop="business_trip_hours" width="45" align="center" ></el-table-column>
    <el-table-column label="请假" prop="month" align="center" >
      <el-table-column label="年假(H)" prop="annual_hours" width="60" align="center" ></el-table-column>
      <el-table-column label="事假(H)" prop="personal_leave_hours" width="60" align="center" ></el-table-column>
      <el-table-column label="病假(H)" prop="sick_hours" width="60" align="center" ></el-table-column>
      <el-table-column label="调休(H)" prop="change_hours" width="60" align="center" ></el-table-column>
      <el-table-column label="婚假(H)" prop="marriage_hours" width="60" align="center" ></el-table-column>
      <el-table-column label="产假(H)" prop="maternity_hours" width="60" align="center" ></el-table-column>
      <el-table-column label="产检假(H)" prop="maternity_check_hours" width="70" align="center" ></el-table-column>
      <el-table-column label="陪产假(H)" prop="paternity_hours" width="70" align="center" ></el-table-column>
      <el-table-column label="育儿假(H)" prop="child_care_hours" width="70" align="center" ></el-table-column>
      <el-table-column label="哺乳假(H)" prop="breastfeeding_hours" width="70" align="center" ></el-table-column>
    </el-table-column>
    <el-table-column label="旷工(天)" prop="skip_work_days" width="45" align="center" ></el-table-column>
    <el-table-column label="漏卡(次)" prop="miss_check_times" width="45" align="center" ></el-table-column>
    <el-table-column label="迟到早退<5分钟(次)" prop="late_or_early_within_5_times" width="75" align="center" ></el-table-column>
    <el-table-column label="迟到早退<30分钟(次)" prop="late_or_early_within_30_times" width="85" align="center" ></el-table-column>
    <el-table-column label="迟到早退>30分钟(次)" prop="late_or_early_over_30_times" width="85" align="center" ></el-table-column>
    <el-table-column label="描述" prop="type" width="70" align="center" ></el-table-column>
    <el-table-column v-for="title in titleList" :label="title.day" :prop="title.day" :key="title.day"
                     align="center">
      <el-table-column :label="title.week" :prop="title.day" :key="title.day" align="center" show-overflow-tooltip min-width="130">
      </el-table-column>
    </el-table-column>
    <el-table-column label="操作" width="70" align="center" fixed = "right">
      <template #default="scope">
        <el-button type="primary" link @click="showDetail(scope.$index, scope.row)">详情</el-button>
      </template>
    </el-table-column>
  </el-table>
  <div style="display: flex;justify-content: flex-end;margin-top: 5px;width: 100%">
    <el-pagination background layout=" sizes, total, prev, pager, next,"
                   :page-sizes="[3,10,20]"
                   :current-page="currentPage"
                   v-model:page-size="pageSize"
                   :total="listSize"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"/>
  </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "AttendanceMonth",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      optionProps: {
        emitPath:false,
        value: 'id',
        label: 'name',
        checkStrictly:true
      },
      sumButton:{
        "component": "button",
        "type": "primary",
        "label": "考勤计算",
        "click": "jsOpenWindow",
        "window": {"component": "frame/FrameForm", "type": "attendance_month_sum","title":"考勤计算",
          "width":800,"height":300}
      },
      searchLoading: false,
      computationLoading:false,
      titleList: [],
      attendanceList: [],
      pageAttendanceList: [],
      pageSize:3,
      listSize:0,
      currentPage:1,
      columnCnt:0,
      deptId:'',
      employeeNo:'',
      employeeName:'',
      sendStatus:'',
      confirmStatus:'',
      selectMonth:moment(moment().month(moment().month()-1)).format('YYYY-MM'),
      laborCompanyId:'',
      showDialog:false,
      selectEmployee:{},
      employeeAttendanceList:[],
      deptCascader:[],
      laborCompanyList:[]
    }
  },
  methods: {
    spanMethod({rowIndex, columnIndex}){
      if (columnIndex <29 || columnIndex === this.titleList.length+30) {
        if (rowIndex % 4 === 0) {
          return {
            rowspan: 4,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getCurrentPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getCurrentPageData();
    },
    getCurrentPageData(){
      if(!this.attendanceList){
        return
      }

      let startIndex = (this.currentPage - 1) * this.pageSize*4;
      let endIndex = this.currentPage * this.pageSize*4;
      this.pageAttendanceList = this.attendanceList.slice(startIndex, endIndex)

    },
    async getMonthReport() {
      let params = {
        deptId: this.deptId,
        employeeNo: this.employeeNo,
        employeeName: this.employeeName,
        confirmStatus: this.confirmStatus,
        selectMonth: this.selectMonth,
        laborCompanyId: this.laborCompanyId,
        sendStatus: this.sendStatus
      }
      console.log(params);
      this.searchLoading = true;
      await this.$http('attendanceMonthService.getAttendanceMonthReport', params, false).then(rtn => {
        //赋值
        this.attendanceList = rtn.returnList;
        this.titleList = rtn.titleList;
        this.listSize = rtn.totalSize;
        this.getCurrentPageData();
        this.searchLoading = false;
      }, errMsg => {
        this.$message.error(errMsg)
        this.searchLoading = false;
      })
    },
    async getDepartmentCascader() {
      this.deptCascader = await this.$http("sysUserDepartmentService.getDepartmentData");
    },
    //获取劳务公司列表
    async getLaborCompany() {
      let params = {modelId: "hr_company"}
      this.laborCompanyList = await this.$http('employeeHRService.getAll', params);
    },
    alertSum() {
      this.$store.dispatch('core/openWindow', {
        component: 'attendance/AttendanceSumForm',
        name: '考勤计算',
        parentData: null,
        width: 800,
        height: 300
      })
    },
    async sumMonthReport() {
      let params = {
        date: this.selectMonth,
        deptId: this.deptId,
        employeeNo: this.employeeNo,
        employeeName: this.employeeName
      }
      this.computationLoading = true;
      await this.$http('attendanceMonthService.sumMonthReport', params, false).then(() => {
        this.$message.success("计算成功");
        this.computationLoading = false;
      }, errMsg => {
        this.$message.error(errMsg)
        console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
        this.computationLoading = false;
      })
    },
    async sendWx() {
      if (this.sendStatus === 'sent') {
        this.$message.error("推送时请勿筛选已推送数据");
        return;
      }
      let params = {
        attendanceList: this.attendanceList,
        selectMonth: this.selectMonth
      }
      await this.$http('wxAttendanceService.sendAttendanceCheck', params).then(res => {
        if (res === 1) {
          this.$message.success("考勤已推送，部分员工推送失败请注意查看");
        }
        if (res === 0) {
          this.$message.success("考勤已全部推送成功");
        }
      });
    },
    getCol() {
      let params = {date: new Date()}
      this.$http('dingAttendanceService.getAllReportColumnValList', params);
    },
    getLeaveCol() {
      let params = {date: new Date()}
      this.$http('dingAttendanceService.getAllLeaveReportList', params);
    },
    async exportMonthReport() {
      let params = {
        attendanceList: this.attendanceList,
        titleList: this.titleList
      }
      let sysFile = await this.$http("attendanceMonthService.exportMonthReportToExcel", params);
      window.location.href = sysFile.url;
    },
    showDetail(index, row) {
      this.$store.dispatch('core/openWindow', {
        component: 'attendance/AttendanceMonthDetail',
        name: '月度考勤详情',
        parentData: row,
        width: 1000,
        height: 700
      })
    }
  },
  created() {
    this.getDepartmentCascader();
    this.getLaborCompany();
  }
}
</script>

<style scoped lang="less">

</style>